/** @format */

import styled, { css } from "styled-components";
import { BaseColor } from "../../../theme/maps/Colors";
import { C, L } from "../../../theme/maps/StatiPresenze";

/** Stessa intestazione, barra degli strumenti e pagina di Turni e Presenze; stesse schede delle Presenze. */
export { BarraStrumenti, Intestazione, Pagina } from "../ViewTurniSettimana/styles";
export { Schede, Stato } from "../ViewPresenze/styles";

/** Occasionale in viola, come nella lista Dipendenti; intermittente nel blu dei turni. */
const VIOLA = { fondo: "#F0EAF8", testo: "#5B3A8C" };

/** Pillole di stato e tipologia, comuni a elenco e pannello. */
const pillole = css`
  .pillola {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    height: 24px;
    padding: 0 9px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }
  .pillola.piccola {
    height: 18px;
    padding: 0 7px;
    font-size: 11px;
  }
  .pillola.rosso {
    background: ${L.anomalia.fondo};
    color: ${L.anomalia.testo};
  }
  .pillola.ambra {
    background: ${L.avviso.fondo};
    color: ${L.avviso.testo};
  }
  .pillola.blu {
    background: ${C.daSvolgere.fondo};
    color: ${C.daSvolgere.testo};
  }
  .pillola.azzurro {
    background: ${L.straordinario.fondo};
    color: ${L.straordinario.testo};
  }
  .pillola.verde {
    background: ${C.inCorso.fondo};
    color: ${C.inCorso.testo};
  }
  .pillola.grigio {
    background: #eceef3;
    color: #41475e;
  }
  .pillola.intermittente {
    background: ${C.daSvolgere.fondo};
    color: ${C.daSvolgere.testo};
  }
  .pillola.occasionale {
    background: ${VIOLA.fondo};
    color: ${VIOLA.testo};
  }
  .attenuato {
    color: ${C.testoSecondario};
  }
  .numeri {
    font-variant-numeric: tabular-nums;
  }
`;

/** Pillole fuori da elenco e pannello (es. lo stato nella testata del pannello). */
export const Pillole = styled.span`
  ${pillole}
  display: inline-flex;
`;

/** Riga di testo sotto l'intestazione: invio automatico e destinatari degli XML. */
export const Regole = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 18px;
  margin-top: 6px;
  font-size: 13px;
  color: ${C.testoSecondario};

  span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  strong {
    color: ${C.testo};
  }
  .mancante {
    font-weight: 700;
    color: ${C.anomalia.testo};
  }
`;

export const COLONNE_ELENCO = "290px 130px 160px 210px minmax(240px, 1fr) 110px";

export const Elenco = styled.div`
  ${pillole}
  overflow: auto;
  background: #fff;
  border: 1px solid ${C.linea};
  border-radius: 12px;
  color: ${C.testo};

  .contenuto {
    min-width: 1060px;
  }
  .riga {
    display: grid;
    grid-template-columns: ${COLONNE_ELENCO};
    align-items: center;
  }
  .riga.testata {
    position: sticky;
    z-index: 2;
    top: 0;
    background: #fff;
    border-bottom: 1px solid ${C.linea};
    font-size: 13px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .riga.testata > div {
    padding: 10px 12px;
  }
  .giorno {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 14px;
    background: ${C.fondoGruppo};
    border-bottom: 1px solid ${C.linea};
    font-size: 14px;
    font-weight: 700;
  }
  .giorno.oggi {
    background: ${C.oggi};
    box-shadow: inset 3px 0 0 ${BaseColor};
  }
  .riga.elemento {
    border-bottom: 1px solid ${C.lineaLeggera};
    cursor: pointer;
  }
  .riga.elemento:hover {
    background: #fafbfe;
  }
  .riga.elemento.aperta {
    background: ${C.oggi};
  }
  .riga.elemento > div {
    min-width: 0;
    padding: 10px 12px;
  }
  .chi {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .chi .testi {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .chi .nome {
    overflow: hidden;
    font-weight: 700;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .chi .sotto {
    display: flex;
    align-items: center;
    gap: 6px;
    overflow: hidden;
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
    white-space: nowrap;
  }
  .chi .sotto > span:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .chi .mancante {
    color: ${C.anomalia.testo};
  }
  .turno .orario {
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .turno .giorno-dopo {
    margin-left: 4px;
    font-size: 11px;
    font-weight: 700;
    color: ${C.testoSecondario};
  }
  .sede {
    overflow: hidden;
    font-size: 13px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .passo {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
  }
  .passo.rosso {
    color: ${C.anomalia.testo};
  }
  .passo.ambra {
    color: ${C.avviso.testo};
  }
  .passo.attenuato {
    font-weight: 500;
  }
  .azione {
    display: flex;
    justify-content: flex-end;
  }
  .vuoto {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 28px 20px;
  }
`;

export const Piedino = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
  color: ${C.testoSecondario};
`;

/** Pannello laterale della comunicazione: stessa struttura del dettaglio turno della vista settimanale. */
export const Corpo = styled.div`
  ${pillole}
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: ${C.testo};

  section {
    display: flex;
    flex-direction: column;
    gap: 9px;
  }
  h3 {
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    color: #3a4160;
  }
  .testa-sezione {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  /* ------------------------------------------------ riquadro dello stato */
  .stato {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border-radius: 10px;
    font-size: 13.5px;
    line-height: 1.45;
  }
  .stato > .anticon {
    margin-top: 3px;
    font-size: 16px;
  }
  .stato strong {
    display: block;
    margin-bottom: 2px;
  }
  .stato .ant-btn {
    margin-top: 8px;
  }
  .stato.rosso {
    background: ${C.anomalia.fondo};
    color: ${C.anomalia.testo};
  }
  .stato.ambra {
    background: ${C.avviso.fondo};
    color: #6e4300;
  }
  .stato.blu,
  .stato.azzurro {
    background: ${C.daSvolgere.fondo};
    color: ${C.daSvolgere.testo};
  }
  .stato.verde {
    background: ${C.inCorso.fondo};
    color: ${C.inCorso.testo};
  }
  .stato.grigio {
    background: ${C.timbrato.fondo};
    color: ${C.timbrato.testo};
  }

  /* ------------------------------------------------ conferma in linea */
  .conferma {
    padding: 14px;
    border: 1px solid ${C.daSvolgere.bordo};
    border-radius: 10px;
    background: #fafbfe;
  }
  .conferma.pericolo {
    border-color: ${L.anomalia.bordo};
    background: #fffafb;
  }
  .conferma p {
    margin: 0;
    font-size: 13.5px;
  }
  .conferma .chi-quando {
    font-size: 12.5px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .conferma label {
    font-size: 12.5px;
    font-weight: 700;
    color: #41475e;
  }
  .conferma .errore {
    font-size: 12.5px;
    font-weight: 600;
    color: ${C.anomalia.testo};
  }
  .pulsanti {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  /* ------------------------------------------------ dati */
  dl {
    display: grid;
    grid-template-columns: 150px 1fr;
    gap: 8px 12px;
    margin: 0;
    font-size: 13.5px;
  }
  dt {
    color: ${C.testoSecondario};
  }
  dd {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 6px;
    min-width: 0;
    margin: 0;
    font-weight: 700;
    overflow-wrap: anywhere;
  }
  dd .ant-btn-link {
    height: auto;
    padding: 0 2px;
    font-weight: 600;
  }
  dd .mancante {
    color: ${C.anomalia.testo};
  }
  dd .secondario {
    flex-basis: 100%;
    font-weight: 500;
    color: ${C.testoSecondario};
  }

  /* ------------------------------------------------ cronologia */
  .eventi {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .eventi li {
    position: relative;
    padding: 0 0 14px 22px;
  }
  .eventi li::before {
    content: "";
    position: absolute;
    top: 14px;
    bottom: 0;
    left: 5px;
    width: 2px;
    background: ${C.lineaLeggera};
  }
  .eventi li:last-child {
    padding-bottom: 0;
  }
  .eventi li:last-child::before {
    display: none;
  }
  .eventi .punto {
    position: absolute;
    top: 5px;
    left: 0;
    width: 12px;
    height: 12px;
    border: 3px solid ${C.daSvolgere.hover};
    border-radius: 50%;
    background: #fff;
  }
  .eventi .punto.verde {
    border-color: ${C.inCorso.punto};
  }
  .eventi .punto.rosso {
    border-color: ${L.anomalia.bordo};
  }
  .eventi .punto.ambra {
    border-color: ${L.avviso.bordo};
  }
  .eventi .punto.grigio {
    border-color: #c3c7d4;
  }
  .eventi .titolo {
    font-size: 13.5px;
    font-weight: 700;
  }
  .eventi .quando {
    font-size: 12px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
  .eventi .messaggio {
    margin-top: 2px;
    font-size: 13px;
    color: #41475e;
    overflow-wrap: anywhere;
  }

  /* ------------------------------------------------ turni collegati */
  .turni-collegati {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .turno-collegato {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 6px 10px;
    padding: 9px 12px;
    border: 1px solid ${C.linea};
    border-radius: 8px;
    background: #fff;
    font-size: 13.5px;
  }
  .turno-collegato.non-valido {
    background: ${C.fondoTotali};
  }
  .turno-collegato.non-valido .orario {
    text-decoration: line-through;
    color: ${C.testoSecondario};
  }
  .turno-collegato .orario {
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }
  .nota {
    margin: 0;
    font-size: 12.5px;
    color: ${C.testoSecondario};
  }

  /* ------------------------------------------------ XML */
  .file {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 8px;
    font-size: 13px;
    font-weight: 600;
    overflow-wrap: anywhere;
  }
  .file .anticon {
    color: ${BaseColor};
  }
  pre.xml {
    max-height: 360px;
    overflow: auto;
    margin: 0;
    padding: 12px 14px;
    border: 1px solid ${C.linea};
    border-radius: 8px;
    background: ${C.fondoTotali};
    font-family: Inconsolata, Menlo, monospace;
    font-size: 12.5px;
    line-height: 1.5;
    white-space: pre;
  }
`;

export const Titolo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: ${C.testo};

  .nome {
    font-size: 17px;
    font-weight: 700;
  }
  .quando {
    font-size: 13px;
    font-weight: 600;
    color: ${C.testoSecondario};
  }
`;

export const Piede = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;

  .motivo {
    flex-basis: 100%;
    margin: 0;
    font-size: 12.5px;
    font-weight: 600;
    color: #4a5170;
  }
`;
